import request from '@/utils/request'
// 首页轮播图
export function bannerImg(data) {
    return request({
        url:'/netbar/api/home/v1/slideshow',
        method:'post',
        data
    })
}
// 首页导航列表
export function IndexList(data) {
    return request({
        url:'/netbar/api/home/v1/select',
        method:'post',
        data
    })
}
// 调用扫一扫
export function RichScan(data) {
    return request({
        url:'/netbar/api/personnel_to_verify/v1/scan',
        method:'post',
        data
    })
}
// 选择网吧列表选择
// /netbar/api/user/v1/select_netbar_user_list
export function chooseBarList(data) {
    return request({
        url:'/netbar/api/user/v1/select_netbar_user_list',
        method:'post',
        data
    })
}
// 获
export function selectUserInformation(data) {
    return request({
        url:'/netbar/api/user/v1/select_user_information_by_netbar_id',
        method:'post',
        data
    })
}